import store from '@/store';
import commonstate from '../constant.js';
import commonUtils from "@/js/workspace/common_util.js";
import requestUtils from "../request_util";
export default {
          //根据PriceCurrencyId来显示币种符号
          getCurrencyByCurrencyId(PriceCurrencyId){
            switch (PriceCurrencyId) {
                case 'USD':
                    return "$";
                case 'DKK':
                    return "DKK";
                case 'UAH':
                    return "UAH";
                case 'UYU':
                    return "UYU";
                case 'CNY':
                    return "¥";
                case 'ILS':
                    return "₪";
                case 'RUB':
                    return "руб";
                 case 'HRK':
                    return "HRK";
                case 'ISK':
                    return "ISK";
                 case 'CAD':
                    return "CA$";
                case 'COP':
                    return "COP";
                case 'HRK':
                        return "HRK";
                case 'CZK':
                        return "Kč";
                case 'DKK':
                        return "DKK";
                case 'DOP':
                        return "₱";
                case 'EGP':
                            return "EGP";
                case 'EUR':
                        return "€";
                case 'GTQ':
                        return "GTQ";
                case 'HTG':
                        return "G";
                case 'JMD':
                        return "JMD";
                case 'HNL':
                        return "HNL";
                case 'HKD':
                        return "HK$";
                case 'HUF':
                        return "Ft";
                case 'ISK':
                        return "ISK";
                case 'INR':
                        return "INR";
                case 'IDR':
                        return "IDR";
                case 'JPY':
                        return "円";
                case 'KZT':
                        return "KZT";
                case 'KES':
                        return "KES";
                case 'KPW':
                        return "원";
                case 'KRW':
                        return "원";
                case 'KWD':
                        return "دينار";
                case 'LBP':
                        return "LBP";
                case 'MYR':
                        return "MYR";
                case 'MUR':
                        return "MUR";
                case 'MXN':
                        return "MXN";
                case 'MAD':
                        return "MAD";
                case 'NAD':
                        return "NAD";
                case 'TWD':
                        return "NT$";
                case 'NZD':
                        return "NZ$";
                case 'NOK':
                        return "NOK";
                case 'PAB':
                        return "PAB";
                case 'PYG':
                        return "₲";
                case 'NOK':
                        return "NOK";
                case 'PEN':
                        return "PEN";
                case 'PHP':
                        return "PHP";
                case 'PLN':
                         return "zł";
                case 'QAR':
                        return "QAR";
                case 'SAR':
                        return "﷼";
                case 'SGD':
                        return "S$";
                case 'ZAR':
                        return "R";
                case 'LKR':
                        return "LKR";
                case 'BRL':
                        return "R$";
                case 'SEK':
                        return "SEK";
                case 'CHF':
                        return "CHF";
                case 'THB':
                        return "฿";
                case 'TRY':
                        return "TL";
                case 'LKR':
                        return "LKR";
                case 'AED':
                        return "AED";
                case 'UAH':
                       return "UAH";
                case 'UYU':
                        return "UYU";
                case 'VND':
                        return "VND";
                default:
                    return "$";
            }
        },
        //多语言根据币种显示对应界面
    switchMoneyType(dirction,value){
        //当用户是免费用户时
        let language = dirction.$i18n.locale;
        if(language=='english'){
            let payMony = dirction.user.payAmount;
            if(payMony){
            if (payMony.indexOf("$") == -1) {
              payMony = "$" + payMony;
              }
              dirction.nowData[0].payMony=payMony;
            }
                  if(value == 'UnlimitedYearly'){
                      if(dirction.user.payLevel == 1){
                    dirction.nowData[1].payMony='$119.5';
                    dirction.nowData[1].oldPayMony='$399'; 
                    dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                     }   
                  }
                   if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                      if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.9'||dirction.user.payAmount=='$19.90'){
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                         return;
                        }
                        //dirction.nowData[0].payMony='24,99€';
                     }
                     if(dirction.user.payType == 'Yearly'){
                        if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                         return;
                        }  
                     }
                 }
                }
                   //匹配流量包
             if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex==2){
                dirction.nowData[0].payMony='$5.9';
                dirction.nowData[1].payMony='$9.9';
               }
        }
        if(language=='deutsch' || language=='france' || language=='italian' || language=='spanish'){
            if(value == 'free'){
               if(dirction.clickIndex == 0){
               dirction.nowData[1].payMony=9+','+99+'€';
               dirction.nowData[2].payMony=119+','+99+'€';
               dirction.nowData[3].payMony=239+','+99+'€';
               dirction.nowData[3].oldPayMony=399+','+99+'€';
               }else{
               dirction.nowData[1].payMony='24,99€';
               dirction.nowData[2].payMony='89,99€';
               }
            }
            //如果购买有限产品
            if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                     if(dirction.user.payType == 'Monthly'){
                       if(dirction.user.payAmount=='7.9'||dirction.user.payAmount=='$7.9'||dirction.user.payAmount=='$7.90'){
                         dirction.nowData[0].payMony='7,99€';
                       }else{
                        dirction.nowData[0].payMony=9+','+99+'€';
                       }
                       
                     }
                     if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.9'||dirction.user.payAmount=='$19.90'){
                         dirction.nowData[0].payMony='19,99€';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                        }else{
                            dirction.nowData[0].payMony='24,99€';
                        }
                       
                     }
                     if(dirction.user.payType == 'Yearly'){
                        if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].payMony='69,99€';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                        }else{
                            dirction.nowData[0].payMony='89,99€';
                        }  
                     }
                    dirction.nowData[1].payMony=239+','+99+'€';
                    dirction.nowData[1].oldPayMony=399+','+99+'€';
                 }else{
                     dirction.nowData[0].payMony='5,99 €';
                     dirction.nowData[1].payMony='9,99 €';
                 }
            }
            //如果购买无限月
            if(value == 'UnlimitedMonthly'){
                       if(dirction.user.payAmount=='17.9'||dirction.user.payAmount=='$17.9'||dirction.user.payAmount=='$17.90'){
                         dirction.nowData[0].payMony='17,99€';
                       }else{
                        dirction.nowData[0].payMony='19,99€';
                       }
                    dirction.nowData[2].payMony=239+','+99+'€';
                    dirction.nowData[2].oldPayMony=399+','+99+'€';
            }
            //如果购买无限年
              if(value == 'UnlimitedYearly'){
                      if(dirction.user.payAmount=='89.9'||dirction.user.payAmount=='$89.9'||dirction.user.payAmount=='$89.90'){
                         dirction.nowData[0].payMony='89.99€';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                       }else{
                        dirction.nowData[0].payMony=119+','+99+'€';
                       }
                    dirction.nowData[1].payMony='119,99€';
                    dirction.nowData[1].oldPayMony='399,99€';    
            }
            //匹配流量包
             if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex==2){
                    dirction.nowData[0].payMony='5,99 €';
                    dirction.nowData[1].payMony='9,99 €';

             }
        }
        if(language =='portuguese'){
             if(value == 'free'){
                if(dirction.clickIndex==0){
               dirction.nowData[1].payMony='R$'+53.99;
               dirction.nowData[2].payMony='R$'+659.99;
               dirction.nowData[3].payMony='R$'+1259.99;
               dirction.nowData[3].oldPayMony='R$'+2+','+'099.99';
                }else{
               dirction.nowData[1].payMony='R$139.99';
               dirction.nowData[2].payMony='R$499.99';  
                }
            }
            //如果购买有限
            if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                     if(dirction.user.payType == 'Monthly'){
                        if(dirction.user.payAmount=='7.9'||dirction.user.payAmount=='$7.9'||dirction.user.payAmount=='$7.90'){
                         dirction.nowData[0].payMony='R$43.99';
                       }else{
                        dirction.nowData[0].payMony='R$'+53.99;
                       }
                      
                     }
                     if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.9'||dirction.user.payAmount=='$19.90'){
                         dirction.nowData[0].payMony='R$109.99';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                         }else{
                            dirction.nowData[0].payMony='R$139.99';
                         }
                         
                     }
                     if(dirction.user.payType == 'Yearly'){
                        if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].payMony='R$369.99';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                        }else{
                        dirction.nowData[0].payMony='R$499.99';
                        }
                     }
                    dirction.nowData[1].payMony='R$'+1259.99;
                    dirction.nowData[1].oldPayMony='R$'+2+','+'099.99';
                 }else{
                     dirction.nowData[0].payMony='R$32.99';
                     dirction.nowData[1].payMony='R$53.99';
                 }
            }
              //如果购买无限月
            if(value == 'UnlimitedMonthly'){
                 if(dirction.user.payAmount=='17.9'||dirction.user.payAmount=='$17.9'||dirction.user.payAmount=='$17.90'){
                         dirction.nowData[0].payMony='R$99.99';
                       }else{
                        dirction.nowData[0].payMony='R$109.99';
                       }
                    dirction.nowData[2].payMony='R$'+1259.99;
                    dirction.nowData[2].oldPayMony='R$'+2+','+'099.99';
            }
            if(value == 'UnlimitedYearly'){
                 if(dirction.user.payAmount=='89.9'||dirction.user.payAmount=='$89.9'||dirction.user.payAmount=='$89.90'){
                         dirction.nowData[0].payMony='R$469.99';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                    }else{
                        dirction.nowData[0].payMony='R$'+659.99;
                    }
                    dirction.nowData[1].payMony='R$599.99';
                    dirction.nowData[1].oldPayMony='R$2,099.99';    
            }
            if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex==2){
                 dirction.nowData[0].payMony='R$32.99';
                 dirction.nowData[1].payMony='R$53.99';
             }
        }
        if(language =='japanese'){
             if(value == 'free'){
                 if(dirction.clickIndex==0){
               dirction.nowData[1].payMony=1+','+180+'円';
               dirction.nowData[2].payMony=13+','+980+'円';
               dirction.nowData[3].payMony=26+','+380+'円';
               dirction.nowData[3].oldPayMony=43+','+980+'円';
                 }else{
               dirction.nowData[1].payMony='2,880円';
               dirction.nowData[2].payMony='9,980円';
                 }
            }
                 //如果购买无限月
            if(value == 'UnlimitedMonthly'){
                 if(dirction.user.payAmount=='17.9'||dirction.user.payAmount=='$17.9'||dirction.user.payAmount=='$17.90'){
                         dirction.nowData[0].payMony='1,980円';
                    }else{
                        dirction.nowData[0].payMony='2,280円';
                    }
                    dirction.nowData[2].payMony=26+','+380+'円';
                    dirction.nowData[2].oldPayMony=43+','+980+'円';
            }
                  //如果购买有限
            if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                     if(dirction.user.payType == 'Monthly'){
                         if(dirction.user.payAmount=='7.9'||dirction.user.payAmount=='$7.9'||dirction.user.payAmount=='$7.90'){
                         dirction.nowData[0].payMony='880円';
                       }else{
                        dirction.nowData[0].payMony=1+','+180+'円';
                       }
                      
                     }
                     if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.90'||dirction.user.payAmount=='$19.9'){
                         dirction.nowData[0].payMony='2,180円';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                         }else{
                            dirction.nowData[0].payMony='2,880円';
                         }
                     }
                     if(dirction.user.payType == 'Yearly'){
                        if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].payMony='7,680円';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                        }else{
                            dirction.nowData[0].payMony='9,980円';
                        }
                     }
                    dirction.nowData[1].payMony=26+','+380+'円';
                    dirction.nowData[1].oldPayMony=43+','+980+'円';
                 }else{
                     dirction.nowData[0].payMony='680円';
                     dirction.nowData[1].payMony='1,180円';
                 }
            }
               if(value == 'UnlimitedYearly'){
                    if(dirction.user.payAmount=='89.9'||dirction.user.payAmount=='$89.9'||dirction.user.payAmount=='$89.90'){
                         dirction.nowData[0].payMony='9,880円';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                       }else{
                        dirction.nowData[0].payMony=13+','+980+'円';
                       }
                    dirction.nowData[1].payMony='12,400円';
                    dirction.nowData[1].oldPayMony='43,980円';    
            }
             if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex == 1){
                 dirction.nowData[0].payMony='680円';
                 dirction.nowData[1].payMony='1,180円';
             }
        }
        if(language =='traditionalChinese'){
             if(value == 'free'){
                 if(dirction.clickIndex==0){
               dirction.nowData[1].payMony='NT$'+299;
               dirction.nowData[2].payMony='NT$'+3+','+499;
               dirction.nowData[3].payMony='NT$'+'6,690';
               dirction.nowData[3].oldPayMony='NT$11,499';
                 }else{
               dirction.nowData[1].payMony='NT$729';
               dirction.nowData[2].payMony='NT$2,599';
                 }
            }
            //如果购买有限
            if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                     if(dirction.user.payType == 'Monthly'){
                         if(dirction.user.payAmount=='7.9'||dirction.user.payAmount=='$7.9'||dirction.user.payAmount=='$7.90'){
                         dirction.nowData[0].payMony='NT$219';
                       }else{
                        dirction.nowData[0].payMony='NT$'+299;
                       }
                       
                     }
                     if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.9'||dirction.user.payAmount=='$19.90'){
                         dirction.nowData[0].payMony='NT$559';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                         }else{
                            dirction.nowData[0].payMony='NT$729';
                         }
                      
                     }
                     if(dirction.user.payType == 'Yearly'){
                         if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].payMony='NT$1,999';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                        }else{
                            dirction.nowData[0].payMony='NT$2,599';
                        }
                       
                     }
                    dirction.nowData[1].payMony='NT$'+'6,690';
                    dirction.nowData[1].oldPayMony='NT$11,499';
                 }else{
                     dirction.nowData[0].payMony='NT$179';
                     dirction.nowData[1].payMony='NT$299';
                 }
            }
                 //如果购买无限月
            if(value == 'UnlimitedMonthly'){
                 if(dirction.user.payAmount=='17.9'||dirction.user.payAmount=='$17.9'||dirction.user.payAmount=='$17.90'){
                         dirction.nowData[0].payMony='NT$499';
                }else{ 
                         dirction.nowData[0].payMony='NT$579';
                }
                    dirction.nowData[2].payMony='NT$'+'6,690';
                    dirction.nowData[2].oldPayMony='NT$11,499';
            }
             if(value == 'UnlimitedYearly'){
                  if(dirction.user.payAmount=='89.9'||dirction.user.payAmount=='$89.9'||dirction.user.payAmount=='$89.90'){
                         dirction.nowData[0].payMony='NT$2,599';
                          dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                    }else{
                        dirction.nowData[0].payMony='NT$'+3+','+499;
                    }
                    dirction.nowData[1].payMony='NT$3,190';
                    dirction.nowData[1].oldPayMony='NT$11,499';    
            }
             if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex==2){
                 dirction.nowData[0].payMony='NT$179';
                 dirction.nowData[1].payMony='NT$299';
             }
        }
         if(language =='chinese'){
             if(value == 'free'){
                if(dirction.clickIndex==0){
               dirction.nowData[1].payMony='¥'+59;
               dirction.nowData[2].payMony='¥'+759;
               dirction.nowData[3].payMony='¥1,499';
               dirction.nowData[3].oldPayMony='¥2,499';
               }else{
               dirction.nowData[1].payMony='¥'+159;
               dirction.nowData[2].payMony='¥'+569;     
                }
            }
            //如果购买有限
            if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                     if(dirction.user.payType == 'Monthly'){
                         if(dirction.user.payAmount=='7.9'||dirction.user.payAmount=='$7.9'||dirction.user.payAmount=='$7.90'){
                         dirction.nowData[0].payMony='¥49';
                       }else{
                        dirction.nowData[0].payMony='¥'+59;
                       }
                     }
                     if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.90'||dirction.user.payAmount=='$19.9'){
                         dirction.nowData[0].payMony='¥119';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                         }else{
                         dirction.nowData[0].payMony='¥'+159;
                         }
                       
                     }
                     if(dirction.user.payType == 'Yearly'){
                        if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].payMony='¥'+439;
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                        }else{
                            dirction.nowData[0].payMony='¥'+569;
                        }
                       
                     }
                    dirction.nowData[1].payMony='¥1,499';
                    dirction.nowData[1].oldPayMony='¥2,499';
                 }else{
                     dirction.nowData[0].payMony='¥35';
                     dirction.nowData[1].payMony='¥59';
                 }
            }
                 //如果购买无限月
            if(value == 'UnlimitedMonthly'){
                 if(dirction.user.payAmount=='17.9'||dirction.user.payAmount=='$17.9'||dirction.user.payAmount=='$17.90'){
                         dirction.nowData[0].payMony='¥114';
                }else{
                    dirction.nowData[0].payMony='¥119';
                }
                   
                    dirction.nowData[2].payMony='¥1,499';
                    dirction.nowData[2].oldPayMony='¥2,499';
            }
                   
             if(value == 'UnlimitedYearly'){
                  if(dirction.user.payAmount=='89.9'||dirction.user.payAmount=='$89.9'||dirction.user.payAmount=='$89.90'){
                        dirction.nowData[0].payMony='¥569';
                        dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                       }else{
                        dirction.nowData[0].payMony='¥'+759;
                       }
                    dirction.nowData[1].payMony='¥740';
                    dirction.nowData[1].oldPayMony='¥2,499';    
            }
             if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex==2){
                 dirction.nowData[0].payMony='¥35';
                 dirction.nowData[1].payMony='¥59';
             }
        }
        
    },
         //活动页面多语言根据币种显示对应界面
    switchActivityMoneyType(dirction,value){
        //当用户是免费用户时
        let language = dirction.$i18n.locale;
        if(language=='english'){
            let payMony = dirction.user.payAmount;
            if(payMony){
            if (payMony.indexOf("$") == -1) {
              payMony = "$" + payMony;
              }
              dirction.nowData[0].payMony=payMony;
            }
                  if(value == 'UnlimitedYearly'){
                          if(dirction.user.payLevel == 1||dirction.user.payLevel == 0){
                                  dirction.nowData[1].payMony='$89.9';
                                  dirction.nowData[1].oldPayMony='$399'; 
                                  dirction.nowData[1].coupon='JMX-YGF-2U6';
                                  dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                                }   
                        if(dirction.user.payAmount=='79.9'||dirction.user.payAmount=='$79.9'||dirction.user.payAmount=='$79.90'){
                                dirction.nowData[0].payMony='$79.9';
                                dirction.nowData[0].oldPayMony='$399'; 
                                dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearlyLow');
                        }
                        
                  }
                   if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                      if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.9'||dirction.user.payAmount=='$19.90'){
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                         return;
                        }
                        //dirction.nowData[0].payMony='24,99€';
                     }
                     if(dirction.user.payType == 'Yearly'){
                             dirction.nowData[1].payMony='$89.9';
                             dirction.nowData[1].coupon='JMX-YGF-2U6';
                        if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                         return;
                        }  
                     }
                 }
                }
                   //匹配流量包
             if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex==2){
                dirction.nowData[0].payMony='$5.9';
                dirction.nowData[1].payMony='$9.9';
               }
        }
        if(language=='deutsch' || language=='france' || language=='italian' || language=='spanish' || language=='nederlands'){
            if(value == 'free'){
               if(dirction.clickIndex == 0){
               dirction.nowData[1].payMony=7+','+99+'€';
               dirction.nowData[1].oldPayMony=9+','+99+'€';
               dirction.nowData[2].payMony=79+','+99+'€';
               dirction.nowData[2].oldPayMony=119+','+99+'€';
               dirction.nowData[3].payMony=179+','+99+'€';
               dirction.nowData[3].oldPayMony=399+','+99+'€';
               }else{
               dirction.nowData[1].payMony='19,99€';
               dirction.nowData[1].oldPayMony='24,99€';
               dirction.nowData[2].payMony='69,99€';
               dirction.nowData[2].oldPayMony='89,99€';
               }
            }
            //如果购买有限产品
            if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                     if(dirction.user.payType == 'Monthly'){
                       if(dirction.user.payAmount=='7.9'||dirction.user.payAmount=='$7.9'||dirction.user.payAmount=='$7.90'){
                         dirction.nowData[0].payMony='7,99€';
                       }else{
                        dirction.nowData[0].payMony=9+','+99+'€';
                       }
                       dirction.nowData[2].payMony=179+','+99+'€';
                       dirction.nowData[2].oldPayMony=399+','+99+'€';
                     }
                     if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.9'||dirction.user.payAmount=='$19.90'){
                         dirction.nowData[0].payMony='19,99€';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                        }else{
                            dirction.nowData[0].payMony='24,99€';
                        }
                       
                        dirction.nowData[2].payMony=179+','+99+'€';
                       dirction.nowData[2].oldPayMony=399+','+99+'€';
                     }
                     if(dirction.user.payType == 'Yearly'){
                        if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].payMony='69,99€';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                        }else{
                            dirction.nowData[0].payMony='89,99€';
                        }  
                        dirction.nowData[1].payMony='89,99€';
                        dirction.nowData[1].oldPayMony=399+','+99+'€';
                        dirction.nowData[1].coupon='JMX-YGF-2U6';
                     }
                    
                 }else{
                     dirction.nowData[0].payMony='5,99 €';
                     dirction.nowData[1].payMony='9,99 €';
                 }
            }
            //如果购买无限月
            if(value == 'UnlimitedMonthly'){
                       if(dirction.user.payAmount=='17.9'||dirction.user.payAmount=='$17.9'||dirction.user.payAmount=='$17.90'){
                         dirction.nowData[0].payMony='17,99€';
                       }else{
                        dirction.nowData[0].payMony='19,99€';
                       }
                    dirction.nowData[2].payMony=179+','+99+'€';
                    dirction.nowData[2].oldPayMony=399+','+99+'€';
            }
            //如果购买无限年
              if(value == 'UnlimitedYearly'){
                if(dirction.user.payAmount=='79.9'||dirction.user.payAmount=='$79.9'||dirction.user.payAmount=='$79.90'){
                        dirction.nowData[0].payMony='79.99€';
                        dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearlyLow');
                }else if(dirction.user.payAmount=='89.9'||dirction.user.payAmount=='$89.9'||dirction.user.payAmount=='$89.90'){
                         dirction.nowData[0].payMony='89.99€';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                       }else{
                        dirction.nowData[0].payMony=119+','+99+'€';
                       }
                    dirction.nowData[1].payMony='89,99€';
                    dirction.nowData[1].oldPayMony='399,99€';  
                    dirction.nowData[1].coupon='JMX-YGF-2U6';  
            }
            //匹配流量包
             if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex==2){
                    dirction.nowData[0].payMony='5,99 €';
                    dirction.nowData[1].payMony='9,99 €';

             }
        }
        if(language =='portuguese'){
             if(value == 'free'){
                if(dirction.clickIndex==0){
               dirction.nowData[1].payMony='R$43,99';
               dirction.nowData[1].oldPayMony='R$53,99';
               dirction.nowData[2].payMony='R$439,99';
               dirction.nowData[2].oldPayMony='R$659,99';
               dirction.nowData[3].payMony='R$949,99';
               dirction.nowData[3].oldPayMony='R$2.099,99';
                }else{
               dirction.nowData[1].payMony='R$109,99';
               dirction.nowData[1].oldPayMony='R$139,99';
               dirction.nowData[2].payMony='R$369,99';  
               dirction.nowData[2].oldPayMony='R$499,99'; 
                }
            }
            //如果购买有限
            if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                     if(dirction.user.payType == 'Monthly'){
                        if(dirction.user.payAmount=='7.9'||dirction.user.payAmount=='$7.9'||dirction.user.payAmount=='$7.90'){
                         dirction.nowData[0].payMony='R$43,99';
                       }else{
                        dirction.nowData[0].payMony='R$53,99';
                       }
                       dirction.nowData[2].payMony='R$949,99';
                       dirction.nowData[2].oldPayMony='R$2.099,99';
                     }
                     if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.9'||dirction.user.payAmount=='$19.90'){
                         dirction.nowData[0].payMony='R$109,99';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                         }else{
                            dirction.nowData[0].payMony='R$139,99';
                         }
                         dirction.nowData[2].payMony='R$949,99';
                    dirction.nowData[2].oldPayMony='R$2.099,99';
                     }
                     
                     if(dirction.user.payType == 'Yearly'){
                        if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].payMony='R$369,99';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                        }else{
                        dirction.nowData[0].payMony='R$469,99';
                        }
                        dirction.nowData[1].payMony='R$469,99';
                        dirction.nowData[1].oldPayMony='R$2.099,99';
                        dirction.nowData[1].coupon='JMX-YGF-2U6';
                     }
                    
                 }else{
                     dirction.nowData[0].payMony='R$32,99';
                     dirction.nowData[1].payMony='R$53,99';
                 }
            }
              //如果购买无限月
            if(value == 'UnlimitedMonthly'){
                 if(dirction.user.payAmount=='17.9'||dirction.user.payAmount=='$17.9'||dirction.user.payAmount=='$17.90'){
                         dirction.nowData[0].payMony='R$99,99';
                       }else{
                        dirction.nowData[0].payMony='R$109,99';
                       }
                    dirction.nowData[2].payMony='R$949,99';
                    dirction.nowData[2].oldPayMony='R$2.099,99';
            }
            if(value == 'UnlimitedYearly'){
                if(dirction.user.payAmount=='79.9'||dirction.user.payAmount=='$79.9'||dirction.user.payAmount=='$79.90'){
                        dirction.nowData[0].payMony='R$439,99';
                        dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearlyLow');
                }else if(dirction.user.payAmount=='89.9'||dirction.user.payAmount=='$89.9'||dirction.user.payAmount=='$89.90'){
                         dirction.nowData[0].payMony='R$469,99';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                    }else{
                        dirction.nowData[0].payMony='R$659,99';
                    }
                    dirction.nowData[1].payMony='R$469,99';
                    dirction.nowData[1].oldPayMony='R$2,099.99';    
                    dirction.nowData[1].coupon='JMX-YGF-2U6';
            }
            if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex==2){
                 dirction.nowData[0].payMony='R$32,99';
                 dirction.nowData[1].payMony='R$53,99';
             }
        }
        if(language =='japanese'){
             if(value == 'free'){
                 if(dirction.clickIndex==0){
               dirction.nowData[1].payMony=880+'円';
               dirction.nowData[1].oldPayMony=1+','+180+'円';
               dirction.nowData[2].payMony=9+','+320+'円';
               dirction.nowData[2].oldPayMony=13+','+980+'円';
               dirction.nowData[3].payMony=19+','+830+'円';
               dirction.nowData[3].oldPayMony=43+','+980+'円';
                 }else{
               dirction.nowData[1].payMony='2,180円';
               dirction.nowData[1].oldPayMony='2,880円';
               dirction.nowData[2].payMony='7,680円';
               dirction.nowData[2].oldPayMony='9,980円';
                 }
            }
                 //如果购买无限月
            if(value == 'UnlimitedMonthly'){
                 if(dirction.user.payAmount=='17.9'||dirction.user.payAmount=='$17.9'||dirction.user.payAmount=='$17.90'){
                         dirction.nowData[0].payMony='1,980円';
                    }else{
                        dirction.nowData[0].payMony='2,280円';
                    }
                    dirction.nowData[2].payMony=19+','+830+'円';
                    dirction.nowData[2].oldPayMony=43+','+980+'円';
            }
                  //如果购买有限
            if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                     if(dirction.user.payType == 'Monthly'){
                         if(dirction.user.payAmount=='7.9'||dirction.user.payAmount=='$7.9'||dirction.user.payAmount=='$7.90'){
                         dirction.nowData[0].payMony='880円';
                       }else{
                        dirction.nowData[0].payMony=1+','+180+'円';
                       }
                       dirction.nowData[2].payMony=19+','+830+'円';
                       dirction.nowData[2].oldPayMony=43+','+980+'円';
                     }
                     if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.90'||dirction.user.payAmount=='$19.9'){
                         dirction.nowData[0].payMony='2,180円';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                         }else{
                            dirction.nowData[0].payMony='2,880円';
                         }
                         dirction.nowData[2].payMony=19+','+830+'円';
                         dirction.nowData[2].oldPayMony=43+','+980+'円';
                     }
                     if(dirction.user.payType == 'Yearly'){
                        if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].payMony='7,680円';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                        }else{
                            dirction.nowData[0].payMony='9,980円';
                        }
                        dirction.nowData[1].payMony='9,980円';
                        dirction.nowData[1].oldPayMony=43+','+980+'円';
                        dirction.nowData[1].coupon='JMX-YGF-2U6';
                     }
                 }else{
                     dirction.nowData[0].payMony='680円';
                     dirction.nowData[1].payMony='1,180円';
                 }
            }
               if(value == 'UnlimitedYearly'){
                if(dirction.user.payAmount=='79.9'||dirction.user.payAmount=='$79.9'||dirction.user.payAmount=='$79.90'){
                        dirction.nowData[0].payMony='9,320円';
                        dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearlyLow');
                }else if(dirction.user.payAmount=='89.9'||dirction.user.payAmount=='$89.9'||dirction.user.payAmount=='$89.90'){
                         dirction.nowData[0].payMony='9,880円';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                       }else{
                        dirction.nowData[0].payMony=13+','+980+'円';
                       }
                    dirction.nowData[1].payMony='9,880円';
                    dirction.nowData[1].oldPayMony='43,980円';    
                    dirction.nowData[1].coupon='JMX-YGF-2U6';
            }
             if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex == 1){
                 dirction.nowData[0].payMony='680円';
                 dirction.nowData[1].payMony='1,180円';
             }
        }
        if(language =='traditionalChinese'){
             if(value == 'free'){
                 if(dirction.clickIndex==0){
               dirction.nowData[1].payMony='NT$'+219;
               dirction.nowData[1].oldPayMony='NT$'+299;
               dirction.nowData[2].payMony='NT$'+2+','+339;
               dirction.nowData[2].oldPayMony='NT$'+'3,499';
               dirction.nowData[3].payMony='NT$'+'5,190';
               dirction.nowData[3].oldPayMony='NT$11,499';
                 }else{
               dirction.nowData[1].payMony='NT$599';
               dirction.nowData[1].oldPayMony='NT$729';
               dirction.nowData[2].payMony='NT$1,999';
               dirction.nowData[2].oldPayMony='NT$2,599';
                 }
            }
            //如果购买有限
            if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                     if(dirction.user.payType == 'Monthly'){
                         if(dirction.user.payAmount=='7.9'||dirction.user.payAmount=='$7.9'||dirction.user.payAmount=='$7.90'){
                         dirction.nowData[0].payMony='NT$219';
                       }else{
                        dirction.nowData[0].payMony='NT$'+299;
                       }
                       dirction.nowData[2].payMony='NT$'+'5,190';
                    dirction.nowData[2].oldPayMony='NT$11,499';
                     }
                     if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.9'||dirction.user.payAmount=='$19.90'){
                         dirction.nowData[0].payMony='NT$559';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                         }else{
                            dirction.nowData[0].payMony='NT$729';
                         }
                      
                         dirction.nowData[2].payMony='NT$'+'5,190';
                        dirction.nowData[2].oldPayMony='NT$11,499';
                     }
                     if(dirction.user.payType == 'Yearly'){
                         if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].payMony='NT$1,999';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                        }else{
                            dirction.nowData[0].payMony='NT$2,599';
                        }
                        dirction.nowData[1].payMony='NT$2,599';
                        dirction.nowData[1].oldPayMony='NT$11,499';
                        dirction.nowData[1].coupon='JMX-YGF-2U6';
                     }
                    
                 }else{
                     dirction.nowData[0].payMony='NT$179';
                     dirction.nowData[1].payMony='NT$299';
                 }
            }
                 //如果购买无限月
            if(value == 'UnlimitedMonthly'){
                 if(dirction.user.payAmount=='17.9'||dirction.user.payAmount=='$17.9'||dirction.user.payAmount=='$17.90'){
                         dirction.nowData[0].payMony='NT$499';
                }else{ 
                         dirction.nowData[0].payMony='NT$579';
                }
                    dirction.nowData[2].payMony='NT$'+'5,190';
                    dirction.nowData[2].oldPayMony='NT$11,499';
            }
             if(value == 'UnlimitedYearly'){
                if(dirction.user.payAmount=='79.9'||dirction.user.payAmount=='$79.9'||dirction.user.payAmount=='$79.90'){
                        dirction.nowData[0].payMony='NT$ 2,339';
                        dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearlyLow');
                }else if(dirction.user.payAmount=='89.9'||dirction.user.payAmount=='$89.9'||dirction.user.payAmount=='$89.90'){
                         dirction.nowData[0].payMony='NT$2,599';
                          dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                    }else{
                        dirction.nowData[0].payMony='NT$'+3+','+499;
                    }
                    dirction.nowData[1].payMony='NT$2,599';
                    dirction.nowData[1].oldPayMony='NT$11,499'; 
                    dirction.nowData[1].coupon='JMX-YGF-2U6';   
            }
             if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex==2){
                 dirction.nowData[0].payMony='NT$179';
                 dirction.nowData[1].payMony='NT$299';
             }
        }
         if(language =='chinese'){
             if(value == 'free'){
                if(dirction.clickIndex==0){
               dirction.nowData[1].payMony='¥'+49;
               dirction.nowData[1].oldPayMony='¥'+59;
               dirction.nowData[2].payMony='¥'+506;
               dirction.nowData[2].oldPayMony='¥'+759;
               dirction.nowData[3].payMony='¥1,127';
               dirction.nowData[3].oldPayMony='¥2,499';
               }else{
               dirction.nowData[1].payMony='¥'+119;
               dirction.nowData[1].oldPayMony='¥'+159;
               dirction.nowData[2].payMony='¥'+439;
               dirction.nowData[2].oldPayMony='¥'+569;
                }
            }
            //如果购买有限
            if(value == 'limited'){
                 if(dirction.clickIndex == 0){
                     if(dirction.user.payType == 'Monthly'){
                         if(dirction.user.payAmount=='7.9'||dirction.user.payAmount=='$7.9'||dirction.user.payAmount=='$7.90'){
                         dirction.nowData[0].payMony='¥49';
                       }else{
                        dirction.nowData[0].payMony='¥'+59;
                       }
                       dirction.nowData[2].payMony='¥1,127';
                     dirction.nowData[2].oldPayMony='¥2,499';
                     }
                     if(dirction.user.payType == 'Quarterly'){
                        if(dirction.user.payAmount=='19.9'||dirction.user.payAmount=='$19.90'||dirction.user.payAmount=='$19.9'){
                         dirction.nowData[0].payMony='¥119';
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponQuartly');
                         }else{
                         dirction.nowData[0].payMony='¥'+159;
                         }
                       
                         dirction.nowData[2].payMony='¥1,127';
                         dirction.nowData[2].oldPayMony='¥2,499';
                     }
                     if(dirction.user.payType == 'Yearly'){
                        if(dirction.user.payAmount=='69.9'||dirction.user.payAmount=='$69.9'||dirction.user.payAmount=='$69.90'){
                         dirction.nowData[0].payMony='¥'+439;
                         dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponlimitedYearly');
                        }else{
                            dirction.nowData[0].payMony='¥'+569;
                        }
                        dirction.nowData[1].payMony='¥569';
                        dirction.nowData[1].oldPayMony='¥2,499';
                        dirction.nowData[1].coupon='JMX-YGF-2U6';
                     }
                 }else{
                     dirction.nowData[0].payMony='¥35';
                     dirction.nowData[1].payMony='¥59';
                 }
            }
                 //如果购买无限月
            if(value == 'UnlimitedMonthly'){
                 if(dirction.user.payAmount=='17.9'||dirction.user.payAmount=='$17.9'||dirction.user.payAmount=='$17.90'){
                         dirction.nowData[0].payMony='¥114';
                }else{
                    dirction.nowData[0].payMony='¥119';
                }
                   
                    dirction.nowData[2].payMony='¥1,127';
                    dirction.nowData[2].oldPayMony='¥2,499';
            }
                   
             if(value == 'UnlimitedYearly'){
                if(dirction.user.payAmount=='79.9'||dirction.user.payAmount=='$79.9'||dirction.user.payAmount=='$79.90'){
                        dirction.nowData[0].payMony='¥506';
                        dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearlyLow');
                }else if(dirction.user.payAmount=='89.9'||dirction.user.payAmount=='$89.9'||dirction.user.payAmount=='$89.90'){
                        dirction.nowData[0].payMony='¥569';
                        dirction.nowData[0].property=dirction.$t('language.paySystem.payCouponunlimitedYearly');
                       }else{
                        dirction.nowData[0].payMony='¥'+759;
                       }
                    dirction.nowData[1].payMony='¥569';
                    dirction.nowData[1].oldPayMony='¥2,499';    
                    dirction.nowData[1].coupon='JMX-YGF-2U6';
            }
             if((value == 'limitedOtherPlan'||value == 'limited') && dirction.clickIndex==2){
                 dirction.nowData[0].payMony='¥35';
                 dirction.nowData[1].payMony='¥59';
             }
        }
        
    },
}


// WEBPACK FOOTER //
// ./src/js/workspace/get_currency.js